import { render, staticRenderFns } from "./qAndA.vue?vue&type=template&id=3747de54&"
import script from "./qAndA.vue?vue&type=script&lang=ts&"
export * from "./qAndA.vue?vue&type=script&lang=ts&"
import style0 from "./qAndA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports